import script from "./Totals.vue?vue&type=script&setup=true&lang=ts"
export * from "./Totals.vue?vue&type=script&setup=true&lang=ts"

import "./Totals.vue?vue&type=style&index=0&id=113469fe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-113469fe"]])

export default __exports__